import _taggedTemplateLiteral from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject;
import { jsx as t } from "react/jsx-runtime";
import e from "styled-components";
import { calculateRem as i, withVDSManager as o } from "@vds-core/utilities";
import { ColorTokens as n } from "@vds-tokens/color";
import { TypographyTokens as r } from "@vds-tokens/typography";
import { Fonts as l } from "@vds-core/typography";
var a = function a(t) {
    return {
      fontSize: "mobile" === t ? r.fontsize.title[16].value : r.fontsize.title[20].value,
      lineHeight: "mobile" === t ? r.lineheight.title[20].value : r.lineheight.title[24].value,
      letterSpacing: "0",
      fontWeight: r.fontweight.bold.value,
      fontFamily: l.VerizonNHGeDS
    };
  },
  f = {
    children: void 0,
    viewport: "desktop",
    padding: "standard"
  },
  p = e.th.withConfig({
    displayName: "StyledTH",
    componentId: "VDS__sc-1a973s3-0"
  })(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", ";\n  color: ", ";\n  text-align: left;\n  vertical-align: bottom;\n  > :nth-child(n) {\n    &:not(:first-child) {\n      margin-top: ", ";\n    }\n  }\n  &:active,\n  &:focus,\n  &:hover {\n    outline: none;\n  }\n"])), function (_ref) {
    var t = _ref.$typographyConfig;
    return "\n    font-size: ".concat(t.fontSize, ";\n    line-height: ").concat(t.lineHeight, ";\n    letter-spacing: ").concat(t.letterSpacing, ";\n    font-family: ").concat(t.fontFamily, ";\n    font-weight: ").concat(t.fontWeight, ";\n  ");
  }, n.elements.primary.onlight.value, i(14)),
  s = function s(e) {
    var i = e.children,
      o = e.viewport;
    return t(p, Object.assign({}, e, {
      $typographyConfig: a(o),
      children: i
    }));
  };
s.defaultProps = f;
var h = o(s);
export { h as default };